import * as actionTypes from "../actions/actionTypes";
import {
    fetchRecordsStart,
    fetchRecordsSuccess,
    fetchRecordsFail,
    clearRecords,
    addRecordStart,
    addRecordSuccess,
    addRecordFail,
    clearAddRecordError,
    clearAddRecordLoading,
    updateRecordFail,
    updateRecordStart,
    updateRecordSuccess,
    clearUpdateRecordError,
    clearUpdateRecordLoading,
    cancelAddRecord,
    cancelUpdateRecord,
    addRecordToBottom,
    updateRecord,
    removeRecord,
    fetchRecordStart,
    fetchRecordSuccess,
    fetchRecordFail,
    clearRecord,
    updateSingleRecord
} from "../utility";

const initialState = {
    records: [],
    record: null,
    isLoading: false,
    isRecordLoading: false,
    isRecordAddLoading: null,
    isRecordUpdateLoading: null,
    error: null,
    recordError: null,
    addRecordError: null,
    updateRecordError: null,
    searchParams: {},
    pagination: {},
    addRecordId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_CONFIGURATIONS_START: return fetchRecordsStart(state);
        case actionTypes.FETCH_CONFIGURATIONS_SUCCESS: return fetchRecordsSuccess(state, action.payload);
        case actionTypes.FETCH_CONFIGURATIONS_FAIL: return fetchRecordsFail(state, action.payload);
        case actionTypes.CLEAR_CONFIGURATIONS: return clearRecords(state);
        case actionTypes.FETCH_CONFIGURATION_START: return fetchRecordStart(state);
        case actionTypes.FETCH_CONFIGURATION_SUCCESS: return fetchRecordSuccess(state, action.payload);
        case actionTypes.FETCH_CONFIGURATION_FAIL: return fetchRecordFail(state, action.payload);
        case actionTypes.CLEAR_CONFIGURATION: return clearRecord(state);
        case actionTypes.ADD_CONFIGURATION: return addRecordToBottom(state, action.payload);
        case actionTypes.ADD_CONFIGURATION_START: return addRecordStart(state);
        case actionTypes.ADD_CONFIGURATION_SUCCESS: return addRecordSuccess(state);
        case actionTypes.ADD_CONFIGURATION_FAIL: return addRecordFail(state, action.payload);
        case actionTypes.ADD_CONFIGURATION_LOADING_CLEAR: return clearAddRecordLoading(state);
        case actionTypes.ADD_CONFIGURATION_ERROR_CLEAR: return clearAddRecordError(state);
        case actionTypes.ADD_CONFIGURATION_CANCEL: return cancelAddRecord(state);
        case actionTypes.UPDATE_CONFIGURATION: return updateRecord(state, action.payload);
        case actionTypes.UPDATE_SINGLE_CONFIGURATION: return updateSingleRecord(state, action.payload);
        case actionTypes.UPDATE_CONFIGURATION_START: return updateRecordStart(state);
        case actionTypes.UPDATE_CONFIGURATION_SUCCESS: return updateRecordSuccess(state);
        case actionTypes.UPDATE_CONFIGURATION_FAIL: return updateRecordFail(state, action.payload);
        case actionTypes.UPDATE_CONFIGURATION_LOADING_CLEAR: return clearUpdateRecordLoading(state);
        case actionTypes.UPDATE_CONFIGURATION_ERROR_CLEAR: return clearUpdateRecordError(state);
        case actionTypes.UPDATE_CONFIGURATION_CANCEL: return cancelUpdateRecord(state);
        case actionTypes.REMOVE_CONFIGURATION: return removeRecord(state, action.payload);
        default:
            return state;
    }
};

export default reducer;